import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PublicShell } from "@/components/PublicLayout";
import { api, errMsg, inr } from "@/lib/api";

const KEYS = ["razorpay_payment_id", "razorpay_payment_link_id", "razorpay_payment_link_reference_id", "razorpay_payment_link_status", "razorpay_signature"];

export default function PayReturn() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading" });
  useEffect(() => {
    const body = Object.fromEntries(KEYS.map((k) => [k, params.get(k) || ""]));
    if (!body.razorpay_payment_link_id || body.razorpay_payment_link_status !== "paid") return setState({ status: "failed", msg: "The payment was not completed. You can try again from your Orders page." });
    api.post("/market/payment-link/verify", body).then((r) => setState({ status: "ok", ...r.data })).catch((e) => setState({ status: "failed", msg: errMsg(e) }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const ok = state.status === "ok";
  return (
    <PublicShell>
      <section className="mx-auto max-w-lg px-5 py-24 text-center" data-testid="pay-return">
        {state.status === "loading" ? <Loader2 className="h-10 w-10 mx-auto animate-spin text-[#086B2D]" /> : ok
          ? <CheckCircle2 className="h-14 w-14 mx-auto text-[#086B2D]" /> : <XCircle className="h-14 w-14 mx-auto text-red-600" />}
        <h1 className="mt-6 text-3xl font-semibold" data-testid="pay-return-title">{state.status === "loading" ? "Confirming your payment…" : ok ? "Payment received" : "Payment not confirmed"}</h1>
        <p className="mt-3 muted" data-testid="pay-return-msg">{ok ? `Order ${state.ref || ""} is confirmed${state.amount ? ` (${inr(state.amount)} paid)` : ""}. The pharmacy will now pack and dispatch your medicines. A receipt has been emailed to you.` : state.msg}</p>
        {state.status !== "loading" && <Link to="/patient/orders"><Button className="mt-8 rounded-full" data-testid="pay-return-orders-btn">View my orders</Button></Link>}
      </section>
    </PublicShell>
  );
}
